// «Base de los montos» del media plan (tanda «grupos, dinero y DV360», contrato §5 y §9.2). Qué columna
// de cada tabla del plan es la inversión en plataforma. La decide el código del backend (fórmulas y
// títulos de columna) y viaja en `proposal.plan_basis`:
//   {ask, tables: [{signature, index, kind, column, column_label, label_cell, source, candidates}]}
// Con `ask` alguna tabla quedó sin decidir: el bloque se pone ámbar y no se aprueba nada hasta elegir.
// Sin la clave (backend viejo o agencia sin el flag) no hay bloque ni bloqueo, como antes.
// Módulo puro para poder testearlo sin montar la vista.

export const BASIS_PIN_PREFIX = 'basis_for::';

const SOURCE_KEYS = {FORMULA: 'source_formula', LABEL: 'source_label', PINNED: 'source_pinned'};

// La duda de base (si el backend la emite) se responde en el bloque, no en la lista de dudas.
export function isPlanBasisQuestion(item) {
    const pin = ((item && item.question) || {}).profile_pin_key;
    return typeof pin === 'string' && pin.startsWith(BASIS_PIN_PREFIX);
}

export function isUndecidedTable(table) {
    return !!table && (table.kind === 'UNDECIDED' || !table.column);
}

export function planBasisState(proposal) {
    const raw = (proposal && proposal.plan_basis) || {};
    const tables = Array.isArray(raw.tables) ? raw.tables.filter(Boolean) : [];
    const hasPlanBasis = tables.length > 0;
    const ask = hasPlanBasis && !!raw.ask;
    const undecided = tables.filter(isUndecidedTable);
    // Si el backend pide elegir pero no marcó ninguna tabla como indecisa, se ofrecen todas: un
    // bloque ámbar sin nada para elegir sería un bloqueo sin salida.
    const askTables = ask ? (undecided.length > 0 ? undecided : tables) : [];
    const decided = tables.filter((table) => !askTables.includes(table));
    return {hasPlanBasis, ask, tables, askTables, decided};
}

// Número de tabla para el usuario (el backend la indexa desde 0).
export function tableNumber(table) {
    const index = Number((table || {}).index);
    return Number.isFinite(index) ? index + 1 : 1;
}

// El título de la columna, o su letra si la planilla no lo tiene.
export function columnLabelOf(entry) {
    return ((entry || {}).column_label || '').trim() || (entry || {}).column || '';
}

export function basisSourceKey(source) {
    return SOURCE_KEYS[source] || null;
}

// Columnas a las que se puede cambiar: las candidatas distintas de la elegida. Sin ninguna no hay
// «Cambiar» (el backend sólo acepta una candidata de la tabla).
export function basisChangeOptions(table) {
    const current = (table || {}).column;
    return ((table || {}).candidates || []).filter((c) => c && c.column && c.column !== current);
}
